<template>
  <div>
    <div class="flex flex-row h-10 bg-grey-extralight flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest">
      <div class="self-center ml-4 text-sm font-semibold text-grey-darkest">Patient Notifications</div>
    </div>
    <!--core main-->
    <div class="flex flex-col overflow-y-auto pb-4" style="height: calc(100vh - 5rem)">
      <div v-if="notifications.length < 1" class="flex flex-col m-4 text-grey-darkest text-sm">Patient does not have any notification</div>
      <div v-for="(n, i) in notifications" :key="i" @click="onNotificationClick(n)" class="flex justify-center flex-row flex-no-shrink flex-no-grow px-4 py-6 border-b border-solid border-grey-lightest hover:bg-blue-lightest cursor-pointer" v-bind:class="[n.is_read ? 'bg-white' : 'bg-grey-extralight']">
        <div class="flex flex-col text-m text-grey-darkest mr-auto">
          {{n.description}}
          <div class="text-xs text-grey mt-2">
            {{n.time}}
          </div>
        </div>
        <div v-if="n.required_action" class="flex text-blue font-semibold text-xs justify-end" @click="requiredAction(n)" style="text-transform: uppercase; width: 160px">
          {{n.required_action}}
        </div>
      </div>
    </div>
    <enquire-now-card v-if="enquireNow" :notification="activeNotification" @closePopup='closePopup'/>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import EnquireNowCard from '@/components/common/modals/EnquireNowCard'
export default {
  components: {
    EnquireNowCard
  },
  data () {
    return {
      enquireNow: false,
      activeNotification: {}
    }
  },
  computed: {
    ...mapGetters({
      customer: 'configuration/getActivePatientProfile',
      requests: 'consultationRequest/getRequests',
      notifications: 'configuration/customerNotifications'
    })
  },
  methods: {
    onNotificationClick: function (n) {
      this.$store.dispatch('configuration/updateReadNotification', n.id)
    },
    requiredAction: function (n) {
      this.activeNotification = n
      if (n.required_action === 'Respond Back') {
        let req = this.requests.find(function (ele) {
          return (ele.consultationRequestId === n.request_id)
        })
        if (req) this.acceptQuery(req)
      } else if (n.required_action === 'Enquire Now') {
        this.enquireNow = true
      }
    },
    acceptQuery: function (n) {
      this.$store.dispatch('consultationRequest/acceptQueriedConsultationRequest', n)
    },
    closePopup: function () {
      this.enquireNow = false
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Customer/CustomerNotification.vue